import queryString from 'querystring';
import {
  CAMPAIGN_QUERY,
  CAMPAIGN_POPULAR_QUERY,
} from '../../areas/campaign/actions/index';
import {
  PAGETYPE_ROOT,
  PAGETYPE_PRODUCT,
  PAGETYPE_CATEGORY,
  PAGETYPE_CAMPAIGN,
  PAGETYPE_STORE,
  PAGETYPE_BRAND,
  PAGETYPE_OTHER,
  SCH_PAGETYPE_FRONT,
  SCH_PAGETYPE_OBJECT,
  SCH_PAGETYPE_OTHER,
  SCH_PAGETYPE_SECTION,
} from './helpers/pagetype';

export default (state, action) => {
  if (!state)
    return {
      pathKey: null,
      pageType: PAGETYPE_OTHER,
      schPageType: SCH_PAGETYPE_OTHER,
      pathChain: [],
      priceData: null,
      placements: [],
      placementsMap: {},
      view: null,
      siteName: '',
    };

  switch (action.type) {
    case '__DANGEROUS_CONFIG_RECEIVE': {
      const { sitename } = action.market;
      return {
        ...state,
        siteName: sitename.replace('é', 'e'), // LeDénicheur,
      };
    }
    case 'CATEGORY_LAYOUT_CHANGED': {
      return {
        ...state,
        view: `category_layout:${action.mode}`,
      };
    }
    case 'ADS_VIEW_UPDATE': {
      return {
        ...state,
        view: action.view,
      };
    }
    case 'ADS_RECEIVE': {
      const placements = action.ads;
      const placementsMap = placements.reduce((result, item) => {
        const category = `${item.isVirtual ? 'v' : ''}${item.categoryId}`;
        const itemKey = `${item.platform}:${item.containerName}:${category}`;
        return {
          ...result,
          [itemKey]: item,
        };
      }, {});
      return {
        ...state,
        placementsMap,
      };
    }
    case 'SHOW_FULL_SEARCH_RESULTS': {
      const { query, pagingInfo } = action;
      const {
        categoriesOffset,
        productsOffset,
        brandsOffset,
        storesOffset,
      } = pagingInfo;
      return {
        ...state,
        pathKey: `search:${query}:${categoriesOffset}:${productsOffset}:${brandsOffset}:${storesOffset}`,
      };
    }
    case 'ROUTE_LOADED': {
      const { data, errors, route, location } = action;

      // Bail out if any error occoured
      if (errors || !route) {
        return state;
      }

      let pageData = {};
      switch (route.name) {
        case 'start':
          pageData = {
            pageType: PAGETYPE_ROOT,
            schPageType: SCH_PAGETYPE_FRONT,
          };
          break;

        case 'product': {
          const { product } = data;
          if (!product || !product.prices || !product.prices.nodes.length) {
            break;
          }
          const priceData = product.prices.nodes[0].price.exclShipping;

          const pathChain =
            product.category &&
            product.category.path
              .reduce((acc, curr) => acc.concat(curr.id), [])
              .concat(product.id);

          pageData = {
            pageType: PAGETYPE_PRODUCT,
            schPageType: SCH_PAGETYPE_OBJECT,
            pathChain,
            priceData,
            view: route.name,
          };
          break;
        }

        case 'category': {
          const { category } = data;
          if (!category) {
            break;
          }

          const pathChain =
            category &&
            category.path.reduce((acc, curr) => acc.concat(curr.id), []);

          pageData = {
            pageType: PAGETYPE_CATEGORY,
            schPageType: SCH_PAGETYPE_SECTION,
            pathChain,
          };
          break;
        }
        case 'campaign': {
          pageData = {
            pathKey: 'campaign-page cat:',
            pageType: PAGETYPE_CAMPAIGN,
            schPageType: SCH_PAGETYPE_SECTION,
          };
          break;
        }
        case 'store': {
          pageData = { pageType: PAGETYPE_STORE };
          break;
        }
        case 'brand': {
          pageData = { pageType: PAGETYPE_BRAND };
          break;
        }
        case 'search': {
          const qs = queryString.decode(
            location && location.search ? location.search.substr(1) : ''
          );
          const {
            q,
            categoriesOffset,
            productsOffset,
            brandsOffset,
            storesOffset,
          } = qs;
          pageData = {
            pathKey: `search:${q || ''}:${categoriesOffset ||
              0}:${productsOffset || 0}:${brandsOffset || 0}:${storesOffset ||
              0}`,
          };
          break;
        }
        default:
          pageData = { pageType: PAGETYPE_OTHER };
          break;
      }

      return {
        ...state,
        priceData: null,
        pathChain: [],
        pathKey: location.key,
        ...pageData,
      };
    }
    case CAMPAIGN_POPULAR_QUERY:
    case CAMPAIGN_QUERY: {
      const { data } = action;
      const { qs, query, categories, offset } = data || {};
      // The campaign ads refresh is throttled, so it should be ok to let
      // most interactions trigger reload (category filter, pagination, search)
      return {
        ...state,
        pathKey: `campaign-page cat:${qs.category || ''} offset:${offset ||
          ''} query:${query || ''}`,
        pathChain: categories,
      };
    }
    default:
  }

  return state;
};
